import { v4 as uuidv4 } from 'uuid'
interface Props {
  [key: string]: any
}

export default function HomPersonWithTabletIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  const uuid = uuidv4()
  return (
    <svg fill="none" viewBox="0 0 49 49" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M32.4157 17.5H31.8887V21.5H32.5917C33.1067 21.5 33.5457 21.188 33.6327 20.76L33.9767 19.057C34.1417 18.243 33.3967 17.5 32.4157 17.5Z"
        fill={`url(#${uuid}paint0_linear)`}
      />
      <path
        d="M16.584 17.5H17.111V21.5H16.408C15.893 21.5 15.454 21.188 15.367 20.76L15.023 19.057C14.858 18.243 15.603 17.5 16.584 17.5Z"
        fill={`url(#${uuid}paint1_linear)`}
      />
      <path
        d="M24.5 6.63306C20.552 6.63306 16.5 7.23306 16.5 15.7661C16.5 16.4491 16.5 20.9901 16.5 21.7201C16.5 24.7661 21.3 28.5001 24.5 28.5001C27.7 28.5001 32.5 24.7671 32.5 21.7201C32.5 20.9901 32.5 16.4491 32.5 15.7661C32.5 7.23306 28.448 6.63306 24.5 6.63306Z"
        fill={`url(#${uuid}paint2_linear)`}
      />
      <path
        d="M24.5 5.04492C20.146 5.04492 19.5 6.68092 19.5 6.68092C17.73 6.94292 15.5 9.53592 15.5 12.4999C15.5 14.1539 15.765 15.3759 16.5 19.4999C17.045 12.9549 17.749 10.4999 19.5 10.4999C20.767 10.4999 21.773 11.4999 24.5 11.4999C26.803 11.4999 27.375 10.4999 29.5 10.4999C32.5 10.4999 32.5 18.4679 32.5 19.4999C33.101 16.4899 33.5 13.9449 33.5 12.4999C33.5 9.06992 30.709 5.04492 24.5 5.04492Z"
        fill={`url(#${uuid}paint3_radial)`}
      />
      <path
        d="M24.7192 4.5C20.5552 4.5 19.5032 6.682 19.5032 6.682C19.4612 7.841 20.0252 8.864 20.0252 8.864C20.0252 8.864 20.7852 10.5 25.1252 10.5C27.7452 10.5 31.5002 8.865 31.5002 4.5C31.5002 4.5 30.6572 4.5 24.7192 4.5Z"
        fill={`url(#${uuid}paint4_radial)`}
      />
      <path
        d="M35.4997 21.5H13.4997C12.3267 21.5 11.4057 22.505 11.5077 23.673L13.1597 42.673C13.2497 43.707 14.1147 44.5 15.1517 44.5H33.8467C34.8837 44.5 35.7497 43.707 35.8387 42.673L37.4907 23.673C37.5937 22.505 36.6727 21.5 35.4997 21.5Z"
        fill={`url(#${uuid}paint5_linear)`}
      />
      <path
        d="M32 26.5C32.8284 26.5 33.5 26.0523 33.5 25.5C33.5 24.9477 32.8284 24.5 32 24.5C31.1716 24.5 30.5 24.9477 30.5 25.5C30.5 26.0523 31.1716 26.5 32 26.5Z"
        fill="#7D38D6"
      />
      <path
        d="M14.5 38.5C14.5 37.948 14.052 37.5 13.5 37.5C14.052 37.5 14.5 37.052 14.5 36.5C14.5 35.948 14.052 35.5 13.5 35.5H12.5H11.5H10.83C9.543 35.5 8.5 36.543 8.5 37.83V41.17C8.5 42.457 9.543 43.5 10.83 43.5H11.5H12.5H13.5C14.052 43.5 14.5 43.052 14.5 42.5C14.5 41.948 14.052 41.5 13.5 41.5C14.052 41.5 14.5 41.052 14.5 40.5C14.5 39.948 14.052 39.5 13.5 39.5C14.052 39.5 14.5 39.052 14.5 38.5Z"
        fill={`url(#${uuid}paint6_linear)`}
      />
      <path
        d="M34.5 38.5C34.5 37.948 34.948 37.5 35.5 37.5C34.948 37.5 34.5 37.052 34.5 36.5C34.5 35.948 34.948 35.5 35.5 35.5H36.5H37.5H38.17C39.457 35.5 40.5 36.543 40.5 37.83V41.17C40.5 42.457 39.457 43.5 38.17 43.5H37.5H36.5H35.5C34.948 43.5 34.5 43.052 34.5 42.5C34.5 41.948 34.948 41.5 35.5 41.5C34.948 41.5 34.5 41.052 34.5 40.5C34.5 39.948 34.948 39.5 35.5 39.5C34.948 39.5 34.5 39.052 34.5 38.5Z"
        fill={`url(#${uuid}paint7_linear)`}
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${uuid}paint0_linear`}
          x1="32.4167"
          x2="33.7507"
          y1="19.5"
          y2="19.5"
        >
          <stop stopColor="#C48F0C" />
          <stop offset="0.251" stopColor="#D19B16" />
          <stop offset="0.619" stopColor="#DCA51F" />
          <stop offset="1" stopColor="#E0A922" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${uuid}paint1_linear`}
          x1="16.583"
          x2="15.249"
          y1="19.5"
          y2="19.5"
        >
          <stop stopColor="#C48F0C" />
          <stop offset="0.251" stopColor="#D19B16" />
          <stop offset="0.619" stopColor="#DCA51F" />
          <stop offset="1" stopColor="#E0A922" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${uuid}paint2_linear`}
          x1="24.5"
          x2="24.5"
          y1="23.7411"
          y2="11.4941"
        >
          <stop offset="0.125" stopColor="#FFDB80" />
          <stop offset="0.141" stopColor="#FED97C" />
          <stop offset="0.449" stopColor="#F4BF3B" />
          <stop offset="0.594" stopColor="#F0B421" />
        </linearGradient>
        <radialGradient
          cx="0"
          cy="0"
          gradientTransform="translate(16.8022 6.16272) scale(23.842)"
          gradientUnits="userSpaceOnUse"
          id={`${uuid}paint3_radial`}
          r="1"
        >
          <stop stopColor="#C26715" />
          <stop offset="0.508" stopColor="#B85515" />
          <stop offset="1" stopColor="#AD3F16" />
        </radialGradient>
        <radialGradient
          cx="0"
          cy="0"
          gradientTransform="translate(23.0676 7.86958) scale(28.1579 29.4437)"
          gradientUnits="userSpaceOnUse"
          id={`${uuid}paint4_radial`}
          r="1"
        >
          <stop stopColor="#C26715" />
          <stop offset="0.508" stopColor="#B85515" />
          <stop offset="1" stopColor="#AD3F16" />
        </radialGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${uuid}paint5_linear`}
          x1="24.0127"
          x2="26.6937"
          y1="22.292"
          y2="44.154"
        >
          <stop stopColor="#9E6EDC" />
          <stop offset="1" stopColor="#7D38D6" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${uuid}paint6_linear`}
          x1="11.5"
          x2="11.5"
          y1="37.394"
          y2="43.394"
        >
          <stop stopColor="#FFCF54" />
          <stop offset="0.261" stopColor="#FDCB4D" />
          <stop offset="0.639" stopColor="#F7C13A" />
          <stop offset="1" stopColor="#F0B421" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${uuid}paint7_linear`}
          x1="37.5"
          x2="37.5"
          y1="37.394"
          y2="43.394"
        >
          <stop stopColor="#FFCF54" />
          <stop offset="0.261" stopColor="#FDCB4D" />
          <stop offset="0.639" stopColor="#F7C13A" />
          <stop offset="1" stopColor="#F0B421" />
        </linearGradient>
      </defs>
    </svg>
  )
}
